import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";

export class PlageHoraireDTO {
    @AutoMap()
    debut!: string;
    @AutoMap()
    fin!: string;
}